import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { DatiOrdinePRModalComponent } from './dati-ordine-pr-modal';

export const DatiOrdinePRModalModule: string = ng
    .module('dati-ordine-pr-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('datiOrdinePRModalComponent', DatiOrdinePRModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/dati-ordine-pr-modal/dati-ordine-pr-modal.module.ts